<script setup lang="ts">
import PasswordTab from '@/components/account/PasswordTab.vue';

definePage({
  name: 'password',
});
</script>

<template>
  <div class="account-container p-6">
    <h2 class="text-2xl font-bold mb-6 text-gray-900">
      Password Settings
    </h2>

    <PasswordTab />
  </div>
</template>

<style scoped>
.account-container {
  max-width: 1200px;
  margin: 0 auto;
}
</style>
